module.exports = __webpack_public_path__ + "static/danos_RGB_white_website-cade8e376aa1f197a9769715bfc0c931.png";